import { RawdataDownloadParamAPIType, RawdataDownloadParamType } from '@/config/rawdata';
import axios from 'axios';
import qs from 'qs';

if (!import.meta.env.VITE_APP_ABMI_API_BASE_URL) {
  throw new Error('ABMI API Env not set: VITE_APP_ABMI_API_BASE_URL');
}

const abmiApiUrl = import.meta.env.VITE_APP_ABMI_API_BASE_URL;

const abmiAxios = axios.create({
  baseURL: abmiApiUrl + '/rawdata'
});
/* get all options for filtering */
export async function getFilterOptions () {
  const apiFct = 'get-filter-options';
  try {
    const response = await abmiAxios.get(apiFct);
    const data = response.data;

    return data;
  } catch (error) {
    return (error);
  }
}

/* get all avaialbe data protocol and available years */
export async function getDataCategroy () {
  const apiFct = 'get-data-category';
  try {
    const response = await abmiAxios.get(apiFct);
    const data = response.data;
    return data;
  } catch (error) {
    return (error);
  }
}

export async function getRawdataFileAsStream (params:RawdataDownloadParamType) {
  const apiFct = 'get-rawdata-file';
  try {
    const response = await abmiAxios.get(apiFct, {
      params,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
      headers: { 'Content-Type': 'application/zip', Accept: '*/*' },
      responseType: 'arraybuffer'
    });
    const data = response.data;
    return data;
  } catch (error) {
    console.error('failed to download', error);
    return error;
  }
}

export async function getRawdataFile (params:RawdataDownloadParamType) {
  const apiFct = 'get-rawdata-file';
  const offgridIdSingle = (params.offgridId.length === 1) ? params.offgridId[0] : 3; // 3 is all both in grid and offgrid
  const paramAPI:RawdataDownloadParamAPIType = {
    offgridId: offgridIdSingle,
    rawdata: params.rawdata,
    region: params.region,
    rotation: params.rotation,
  };
  try {
    const response = await abmiAxios.get(apiFct, {
      params: paramAPI,
      paramsSerializer: paramAPI => {
        return qs.stringify(paramAPI, { arrayFormat: 'repeat' });
      }
    });
    const data = response.data;
    return data;
  } catch (error) {
    console.error('failed to download', error);
    return error;
  }
}

const abmiApi = {
  getFilterOptions,
  getDataCategroy
};

export default abmiApi;
